import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {City} from "../model/city.model";
import {AbstractSettingsService} from './abstract-settings.service';

@Injectable()
export class CityService extends AbstractSettingsService {
    constructor(httpClient: HttpClient, configService: ConfigService) {
        super(httpClient, configService);
    }

    public async getAll(channelPartnerId : string): Promise<City[]> {
        const settingUrl =  channelPartnerId ? `/settings?channelPartnerId=${channelPartnerId}` : '/settings';
        const settings = await this.getSettingsWithURL(settingUrl);
        return settings.city.map(i => i.city)
            .map(name => <City>{name: name});
    }
}
